module.exports = __webpack_public_path__ + "static/fonts/OpenSans-Bold.0b38161.eot";


//////////////////
// WEBPACK FOOTER
// ./static/font/OpenSans-Bold.eot
// module id = 4km8
// module chunks = 3